import React, { Component } from 'react'
import { connect } from 'react-redux'
import BarraNavegacao from './BarraNavegacao'
import ModalAlterarSenhaUsuario from '../usuario/empresa/ModalAlterarSenhaUsuario';

export class Template extends Component {
  render () {
    const isAuth = this.props.authentication && this.props.authentication.isAuthenticated
    return (
      <>
        <div style={{
          display: isAuth ? 'block' : 'none',
          position: 'sticky',
          top: 0,
          zIndex: 200,
          flexShrink: 0
        }}>
          <BarraNavegacao onToggleSidebar={this.props.onToggleSidebar} sidebarOpen={this.props.sidebarOpen} />
        </div>
        {isAuth && <ModalAlterarSenhaUsuario />}
      </>
    )
  }
}

const mapStateToProps = ({ authentication }) => ({ authentication });

export default connect(mapStateToProps)(Template)
